import {
  type PropsWithChildren,
  useState,
} from 'react';

import { DrawerContext } from '@/components/Drawer/context/drawerContextShared';

export function DrawerProvider({ children }: PropsWithChildren) {
  const [activeDrawer, setActiveDrawer] = useState<string | null>(null);

  return (
    <DrawerContext.Provider
      value={{
        activeDrawer,
        openDrawer: setActiveDrawer,
        closeDrawer: () => setActiveDrawer(null),
      }}
    >
      {children}
    </DrawerContext.Provider>
  );
}
